module.exports = __webpack_public_path__ + "img/icon-appliances.b3c11ca0.svg";